import { EClickType } from '@gem-sdk/heatmap-react';

/**
 * Heatmap click type filter
 */
export enum EHeatmapClickType {
  /** Return all clicks (default) */
  ALL = 'ALL',
  /** Clicks with no effect (no navigation, no state change) */
  DEAD = 'DEAD',
  /** Clicks followed by JavaScript errors */
  ERROR = 'ERROR',
  /** The first click of the session */
  FIRST = 'FIRST',
  /** The last click of the session */
  LAST = 'LAST',
  /** Rapid clicks in a small area, indicating user frustration */
  RAGE = 'RAGE',
  /** Normal click with no special behavior (fallback type) */
  STANDARD = 'STANDARD',
}

export const MAP_CLICK_TYPE_TO_KEY: Record<EClickType, EHeatmapClickType> = {
  [EClickType.All]: EHeatmapClickType.ALL,
  [EClickType.Rage]: EHeatmapClickType.RAGE,
  [EClickType.Dead]: EHeatmapClickType.DEAD,
  [EClickType.Error]: EHeatmapClickType.ERROR,
  [EClickType.First]: EHeatmapClickType.FIRST,
  [EClickType.Last]: EHeatmapClickType.LAST,
  [EClickType.Standard]: EHeatmapClickType.STANDARD,
};

export enum EHeatmapClickTooltipKey {
  TOTAL_CLICKS = 'TOTAL_CLICKS',
  TOTAL_ORDERS = 'TOTAL_ORDERS',
  TOTAL_REVENUE = 'TOTAL_REVENUE',
  CONVERSION_RATE = 'CONVERSION_RATE',
  REVENUE_PER_CLICK = 'REVENUE_PER_CLICK',
  REVENUE_PER_SESSION = 'REVENUE_PER_SESSION',
}
